import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Button = styled(Link)`
  display: inline-block;
  padding: 15px 30px;
  font-size: 1.2rem;
  border-radius: 30px;
  background: #e1d6c0;
  color: #0d0d0d;
  font-weight: 700;
  transition: opacity 0.2s;
  text-align: center;
  &:hover { opacity: 0.8; }
`;

const PickupButton = () => (
  <Button to="/menu">Pickup</Button>
);

export default PickupButton;
